// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_closed_now = /** @type {(inputs: {}) => string} */ () => {
	return `Closed`
};

const el_closed_now = /** @type {(inputs: {}) => string} */ () => {
	return `Κλειστά`
};

const ru_closed_now = /** @type {(inputs: {}) => string} */ () => {
	return `Закрыто`
};

const he_closed_now = /** @type {(inputs: {}) => string} */ () => {
	return `סגור`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const closed_now = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.closed_now(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("closed_now", locale)
	if (locale === "en") return en_closed_now(inputs)
	if (locale === "el") return el_closed_now(inputs)
	if (locale === "ru") return ru_closed_now(inputs)
	if (locale === "he") return he_closed_now(inputs)
	return "closed_now"
};